export default __webpack_public_path__ + "pdf/loghub_report_sample.c2723d89.pdf";